import { InboxMessageActionTypes, InboxMessagesActions, InboxMessagesState } from './actions';

export const reducer = (state: InboxMessagesState, action: InboxMessagesActions): InboxMessagesState => {
  switch (action.type) {
    case InboxMessageActionTypes.GET_MESSAGES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
